import React from 'react'
import DisputeWindowTime from './DisputeWindowTime';
import { getTokenSymbol, formatDateTime, getBackgroundColor, formatSmartDecimal, getFormatedWeb3Address, sendGasFeeAsUsdt, getMarketFeeToken } from '../../utils/helpers';
import { APPEAL, DARK_THEME, DISPUTE, WINNER_PROPOSAL_MODE, USDT_MOCK_VALUE } from '../../utils/constants';
import { UNDER_DISPUTE_CHECK } from '../../utils/MarketStatus';
import { Accordion } from 'react-bootstrap';
import MarketOutcome from './MarketOutcome';
import { encodeFunctionData } from 'viem';
import { getExtendTimeAndSignature } from '../../utils/services';
import OracleAbi from '../../utils/OracleAbi.json';
import { notifyError } from '../Toast';
import { DEFAULT_ERROR_HEADING } from '../../utils/ConstantMessages';

const PoolFinalization = ({
    t,
    poolsdetail,
    winnerData,
    isPoolPrivate,
    handleShowReasoning,
    publicPoolResolverText,
    poolDisputed,
    isAppealed,
    smartAccount,
    handleShowCreateDispute,
    revealWinnerUi,
    revealWinner,
    timeExtendUi,
    poolUnderDisputeUi,
    publicPoolResolverAddress,
    disputeTimer,
    setDisputeTimer,
    extendDisputeTimer,
    ownermatch,
    handleShow14,
    isClaimWindowOpen,
    claimNotDisputed,
    decideWinnerTime,
    claimEligibility,
    setClaimNotDisputed,
    userliquidity,
    percentageindiv,
    web3,
    pair,
    price,
    swapbalance,
    poolDisputedWinner,
    claimcheck,
    claimvalue,
    sumOfClaimvalue,
    getClaims,
    poolPnl,
    theme,
    isPublicPoolResolverAi,
    disputeOrAppealText,
    decidedByText,
    setShowCreateDisputeOffCanvas,
    setShowEvidence,
    setShowEvidenceHistory,
    investedAmount,
    totalPayout,
    tokenData,
    setWinnerProposalMode,
    reSubmitOrFinalizeSpinner,
    showresubmit,
    setShowResubmit,
    oracleExtendedTimeNo,
    gasEstimateInUsdt,
    gasFeesSpinner,
    getEstimatedTxGasFee,
    setGasFeesSpiner,
    setPoolStatus,
    openClaimModal,
    hasTooEarlyHistory
}) => {

    const handleEstimateReSubmitAppealGas = async () => {
        setShowResubmit(true);
        setGasFeesSpiner(true)
        try {
            const timeSignature = await getExtendTimeAndSignature(publicPoolResolverAddress, smartAccount);
            if (timeSignature) {
                const callArgs = [
                    {
                        to: publicPoolResolverAddress,
                        data: encodeFunctionData({
                            abi: OracleAbi,
                            functionName: "extendTime",
                            args: [timeSignature.epoch, timeSignature.signature],
                        }),
                    },
                    { to: getMarketFeeToken(poolsdetail?.token).address, data: sendGasFeeAsUsdt(USDT_MOCK_VALUE, getMarketFeeToken(poolsdetail?.token).decimals) },
                ];
                await getEstimatedTxGasFee(callArgs, false);
            }
        } catch (err) {
            console.error('Error in extend time gas fee estimation:', err);
        }
    };

    const handleCreateDisputeOrAppeal = () => {
        if (!smartAccount) {
            notifyError(DEFAULT_ERROR_HEADING, "Please connect your wallet");
            return;
        }
        if (disputeOrAppealText === DISPUTE) {
            setWinnerProposalMode(WINNER_PROPOSAL_MODE.DISPUTE);
            setShowCreateDisputeOffCanvas(true);
        } else if (disputeOrAppealText === APPEAL) {
            setWinnerProposalMode(WINNER_PROPOSAL_MODE.APPEAL);
            handleShowCreateDispute();
        }
    };

    const handleEstimateFinalizeWinnerGas = async () => {
        setShowResubmit(true);
        setGasFeesSpiner(true);
        try {
            const callArgs = [
                {
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({
                        abi: OracleAbi,
                        functionName: "calculateWinner",
                    }),
                },
                { to: getMarketFeeToken(poolsdetail?.token).address, data: sendGasFeeAsUsdt(USDT_MOCK_VALUE, getMarketFeeToken(poolsdetail?.token).decimals) },
            ];
            await getEstimatedTxGasFee(callArgs, false);
        } catch (err) {
            console.error('Error in finalize gas fee estimation:', err);
        }
    };

    const getClaimButtonState = () => {
        const winnerOptionId = Number(poolDisputedWinner)
            ? poolsdetail?.options?.find(opt => opt.choiceIndex === Number(poolDisputedWinner))?._id
            : poolsdetail?.winnerOption?.optionId;
        const hasInvestedShares = +(swapbalance?.[winnerOptionId]) !== 0;
        const hasLiquidity = +(userliquidity) !== 0;
        const canClaimBase = !claimcheck && smartAccount && (hasInvestedShares || hasLiquidity || claimvalue?.resolverReward > 0);
        const canClaim = (canClaimBase && isClaimWindowOpen && !claimNotDisputed);
        return { canClaim, hasInvestedShares };
    };
    const { canClaim, hasInvestedShares } = getClaimButtonState();
    const isResolutionProposer = poolsdetail?.winnerProposer?.user?.walletAddress?.toLowerCase() === smartAccount?.toLowerCase();
    const canDispute = isPublicPoolResolverAi || !isResolutionProposer;

    return (
        <>
            {/* PNL ui.... */}
            {/* {claimcheck && (
                <div className="killpool-parent">
                    <p>{t('PnL')}</p>
                    <h6 style={{ color: !isNaN(poolPnl) && poolPnl >= 0 ? "var(--green-text)" : "var(--logout-text)", }} >
                        {isNaN(poolPnl) ? "$0.00" :
                            poolPnl >= 0 ? `$${formatNumbers(+poolPnl)}` : `$${formatNumbers(Math.abs(+poolPnl))}`}
                    </h6>
                </div>
            )} */}
            {poolsdetail?.poolFinalized && poolsdetail?.winnerOption && (
                <>
                    {!canClaim && !claimcheck && (
                        <>
                            {isClaimWindowOpen && claimNotDisputed && disputeOrAppealText === DISPUTE && (
                                <>
                                    <div className="market-outcome">

                                        <h5 className="head-text">Market Outcome</h5>

                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                                    <div className="left-text">
                                                        <p>Outcome determined {" "}
                                                            {
                                                                isPublicPoolResolverAi && (
                                                                    <>
                                                                        by {
                                                                            theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} /> :
                                                                                <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                                                        }
                                                                    </>
                                                                )
                                                            }

                                                        </p>
                                                        <h6 style={{ marginTop: "15px" }}><span style={{ backgroundColor: getBackgroundColor(poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId), theme, poolsdetail?.options?.length) }} className='circle-dot'></span>{winnerData?.winnerOption}</h6>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="parent-body">
                                                        {poolsdetail?.version > 2 && (
                                                            <div className="left-text">
                                                                <p>{isPublicPoolResolverAi ? "Resolution Triggered by" : "Closed by"}</p>
                                                                <h6>
                                                                    <img src={poolsdetail?.winnerProposer?.user?.profilePic} alt="img" className='img-fluid' />
                                                                    {poolsdetail?.winnerProposer?.user?.name || getFormatedWeb3Address(poolsdetail?.winnerProposer?.user?.walletAddress, true)}
                                                                    <span>{poolsdetail?.winnerProposer?.role}</span>
                                                                </h6>
                                                            </div>
                                                        )}
                                                        <div className="left-text">
                                                            <p>Proposed Time</p>
                                                            <h6>{formatDateTime(poolsdetail?.winnerOption?.createdAt)}</h6>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        {
                                            canDispute ? <><button
                                                onClick={canDispute && handleCreateDisputeOrAppeal}
                                                className='btn-dispute'
                                                disabled={!canDispute}
                                            >
                                                <h6>CREATE A DISPUTE</h6>

                                                <DisputeWindowTime
                                                    claimNotDisputed={claimNotDisputed}
                                                    decideWinnerEndTime={decideWinnerTime}
                                                    claimEligibility={claimEligibility}
                                                    setClaimNotDisputed={setClaimNotDisputed}
                                                    disputeOrAppealText={disputeOrAppealText}
                                                    setPoolStatus={setPoolStatus}
                                                    isAppealed={isAppealed}
                                                />
                                            </button></> : <>
                                                <div className="dispute-ends-parent">
                                                    <p>Dispute window ends in</p>
                                                    <DisputeWindowTime
                                                        claimNotDisputed={claimNotDisputed}
                                                        decideWinnerEndTime={decideWinnerTime}
                                                        claimEligibility={claimEligibility}
                                                        setClaimNotDisputed={setClaimNotDisputed}
                                                        disputeOrAppealText={disputeOrAppealText}
                                                        setPoolStatus={setPoolStatus}
                                                        isAppealed={isAppealed}
                                                    />
                                                </div>
                                            </>
                                        }


                                        <p className="bottom-para">
                                            Review full resolution history.{' '}
                                            <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View History</a>
                                        </p>
                                    </div>

                                </>
                            )}
                            {poolsdetail?.status === UNDER_DISPUTE_CHECK && (
                                <>
                                    <div className="market-outcome">
                                        <h5 className="head-text">Market Outcome</h5>
                                        <div className="outcomes-box">
                                            <h6><span style={{ backgroundColor: getBackgroundColor(poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId), theme, poolsdetail?.options?.length) }} className='circle-dot'></span>{winnerData?.winnerOption}</h6>
                                        </div>
                                        <div className="raised-dispute">
                                            <div className="upper-text">
                                                <h6>{poolsdetail?.disputeData?.caller?.toLowerCase() === smartAccount?.toLowerCase() ? 'You have raised a dispute' : 'A Dispute Has Been Raised'}</h6>
                                                <p>Dispute Resolution by{' '}
                                                    {
                                                        theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "100px" }} /> :
                                                            <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "100px" }} />
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                        <p className="bottom-para">
                                            Review full resolution history.{' '}
                                            <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View History</a>
                                        </p>
                                    </div>
                                </>
                            )}
                            {isClaimWindowOpen && claimNotDisputed && disputeOrAppealText === APPEAL && (
                                <>
                                    <div className="market-outcome">

                                        <h5 className="head-text">Market Outcome</h5>

                                        <div className="outcomes-box">
                                            <h6><span style={{ backgroundColor: getBackgroundColor(poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId), theme, poolsdetail?.options?.length) }} className='circle-dot'></span>{winnerData?.winnerOption}</h6>
                                        </div>
                                        <div className="decidedby">
                                            <p>Decided By</p>
                                            {
                                                theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} /> :
                                                    <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                            }
                                        </div>
                                        <div className="raised-dispute">
                                            <div className="upper-text pb-0">
                                                <h6>Dispute resolved. Want to appeal?</h6>
                                                <p>The appeal escalates the decision to Ethos (human review)</p>
                                            </div>
                                            <button onClick={handleCreateDisputeOrAppeal} className='btn-dispute' style={{ marginTop: "20px", marginBottom: "0" }}>
                                                <h6>CREATE Appeal</h6>
                                                <DisputeWindowTime
                                                    claimNotDisputed={claimNotDisputed}
                                                    decideWinnerEndTime={decideWinnerTime}
                                                    claimEligibility={claimEligibility}
                                                    setClaimNotDisputed={setClaimNotDisputed}
                                                    disputeOrAppealText={disputeOrAppealText}
                                                    setPoolStatus={setPoolStatus}
                                                    isAppealed={isAppealed}
                                                />
                                            </button>
                                        </div>
                                        <p className="bottom-para">
                                            Review full resolution history.{' '}
                                            <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }} >View History</a>
                                        </p>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    {!poolUnderDisputeUi &&
                        !timeExtendUi &&
                        isClaimWindowOpen &&
                        !(claimNotDisputed && (disputeOrAppealText === APPEAL || disputeOrAppealText === DISPUTE)) && (
                            <>
                                <MarketOutcome
                                    winnerData={winnerData}
                                    poolsdetail={poolsdetail}
                                    setShowEvidence={setShowEvidence}
                                    setShowEvidenceHistory={setShowEvidenceHistory}
                                    hasTooEarlyHistory={hasTooEarlyHistory}
                                />
                                {(poolsdetail?.version <= 2 ? hasInvestedShares : sumOfClaimvalue > 0) && (
                                    <div className="claim-reward-ui">
                                        <h5 className="head-text">Claim Rewards</h5>
                                        <div className="bottom-claim-box">
                                            {/* {claimvalue?.liquidityReward &&
                                            <div className="single-value">
                                                <p>Liquidity Reward</p>
                                                <h6>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.liquidityReward)}</h6>
                                            </div>} */}
                                            {/* {claimvalue?.creatorReward && (
                                            <div className="single-value">
                                                <p>Creation Reward</p>
                                                <h6>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.creatorReward)}</h6>
                                            </div>)} */}
                                            {/* {claimvalue?.resolverReward && (
                                            <div className="single-value">
                                                <p>Closing Reward</p>
                                                <h6>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.resolverReward)}</h6>
                                            </div>)} */}
                                            {/* {claimvalue?.resolverBondAmount > 0 &&
                                        <div className="single-value">
                                            <p>Resolver Bond Amount</p>
                                            <h6><span className='green-box'>Refunded</span>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.resolverBondAmount)}</h6>
                                        </div>} */}
                                            {/* {claimvalue?.appealRefunds > 0 &&
                                        <div className="single-value">
                                            <p>Appeal Bond Amount</p>
                                            <h6><span className='green-box'>Refunded</span>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.appealRefunds)}</h6>
                                        </div>} */}
                                            {/* {claimvalue?.disputeRefunds &&
                                        <div className="single-value">
                                            <p>Dispute Bond Amount</p>
                                            <h6><span className='green-box'>Refunded</span>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.disputeRefunds)}</h6>
                                        </div>} */}
                                            {claimvalue?.shareReward &&
                                                <div className="single-value">
                                                    <p>Shares reward</p>
                                                    <h6>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(claimvalue?.shareReward)}</h6>
                                                </div>}
                                            {/* {poolsdetail?.version > 2 && (
                                                <div className="single-value">
                                                    <p style={{ color: "var(--text-color1)" }}>Total Claimable Amount</p>
                                                    <h6>{getTokenSymbol(tokenData?.tokenSymbol)}{formatSmartDecimal(sumOfClaimvalue)}</h6>
                                                </div>
                                            )} */}
                                            <button
                                                onClick={canClaim ? () => openClaimModal(true) : undefined}
                                                className={`btn-claim${!canClaim ? ' disabled' : ''}`}
                                                disabled={!canClaim}
                                            >
                                                {claimcheck ? t('Claimed') : t('Claim')}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    {((timeExtendUi || poolUnderDisputeUi) && poolDisputed && isAppealed) && (
                        <MarketOutcome
                            winnerData={winnerData}
                            poolsdetail={poolsdetail}
                            setShowEvidence={setShowEvidence}
                            setShowEvidenceHistory={setShowEvidenceHistory}
                            revealWinner={revealWinner}
                            revealWinnerUi={revealWinnerUi}
                            timeExtendUi={timeExtendUi}
                            extendDisputeTimer={extendDisputeTimer}
                            publicPoolResolverAddress={publicPoolResolverAddress}
                            disputeTimer={disputeTimer}
                            setDisputeTimer={setDisputeTimer}
                            reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                            showresubmit={showresubmit}
                            setShowResubmit={setShowResubmit}
                            handleEstimateReSubmitAppealGas={handleEstimateReSubmitAppealGas}
                            handleEstimateFinalizeWinnerGas={handleEstimateFinalizeWinnerGas}
                            oracleExtendedTimeNo={oracleExtendedTimeNo}
                            gasEstimateInUsdt={gasEstimateInUsdt}
                            gasFeesSpinner={gasFeesSpinner}
                            poolUnderDisputeUi={poolUnderDisputeUi}
                            poolDisputed={poolDisputed}
                            isAppealed={isAppealed}
                            hasTooEarlyHistory={hasTooEarlyHistory}
                        />
                    )}
                </>
            )
            }
            {revealWinnerUi && (
                <MarketOutcome
                    winnerData={winnerData}
                    poolsdetail={poolsdetail}
                    setShowEvidence={setShowEvidence}
                    setShowEvidenceHistory={setShowEvidenceHistory}
                    revealWinner={revealWinner}
                    revealWinnerUi={revealWinnerUi}
                    timeExtendUi={timeExtendUi}
                    extendDisputeTimer={extendDisputeTimer}
                    publicPoolResolverAddress={publicPoolResolverAddress}
                    disputeTimer={disputeTimer}
                    setDisputeTimer={setDisputeTimer}
                    reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                    showresubmit={showresubmit}
                    setShowResubmit={setShowResubmit}
                    handleEstimateReSubmitAppealGas={handleEstimateReSubmitAppealGas}
                    handleEstimateFinalizeWinnerGas={handleEstimateFinalizeWinnerGas}
                    oracleExtendedTimeNo={oracleExtendedTimeNo}
                    gasEstimateInUsdt={gasEstimateInUsdt}
                    gasFeesSpinner={gasFeesSpinner}
                    poolUnderDisputeUi={poolUnderDisputeUi}
                    poolDisputed={poolDisputed}
                    isAppealed={isAppealed}
                    hasTooEarlyHistory={hasTooEarlyHistory}
                />
            )}
            {
                poolsdetail?.poolFinalized && !poolsdetail?.winnerOption && (
                    <div className="winnerdecideui" style={{ border: "none", padding: "0" }}>
                        {(isPoolPrivate || !isPublicPoolResolverAi) && ownermatch
                            ? <p className='undersidputetext'>{t("Market is Closed!")}</p>
                            : (isPoolPrivate || !isPublicPoolResolverAi)
                                ? <p className='undersidputetext'>{t("Market is Closed! Please wait for the creator to decide winner.")}</p>
                                :
                                <div className='market-outcome'>
                                    <h5 className="head-text">Market Outcome</h5>
                                    <Accordion className={poolsdetail?.version < 3 ? 'no-toggle' : ''}>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <div className="left-text">
                                                    <p>Resolution in Progress {" "}
                                                        {
                                                            isPublicPoolResolverAi && (
                                                                <>
                                                                    by <br /> {
                                                                        theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", marginTop: "15px" }} /> :
                                                                            <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", marginTop: "15px" }} />
                                                                    }
                                                                </>
                                                            )
                                                        }

                                                    </p>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="parent-body">
                                                    <div className="left-text">
                                                        <p>Closed by</p>
                                                        <h6>
                                                            <img src={poolsdetail?.winnerProposer?.user?.profilePic} alt="img" className='img-fluid' />
                                                            {poolsdetail?.winnerProposer?.user?.name || getFormatedWeb3Address(poolsdetail?.winnerProposer?.user?.walletAddress, true)}
                                                            <span>{poolsdetail?.winnerProposer?.role}</span>
                                                        </h6>
                                                    </div>
                                                    <div className="left-text">
                                                        <p>Proposed Time</p>
                                                        <h6>{formatDateTime(poolsdetail?.winnerProposer?.createdAt)}</h6>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                        }
                        {((isPoolPrivate || !isPublicPoolResolverAi) && ownermatch) && (
                            <button onClick={() => handleShow14()} className="btncreatedispute" style={{ background: "var(--button-bg)", color: "var(--text-color6)", border: "none" }}>{t('Decide Winner')}</button>
                        )}
                    </div>
                )
            }
        </>
    )
}

export default PoolFinalization
